import React from 'react';
import PropTypes from 'prop-types';
import {isNumber} from 'lodash';
import styled from 'styled-components';

import {colors} from 'styles/shared';

const ButtonStyled = styled.button`
  width: ${props => props.width};
  height: 5rem;
  border: 0.2rem solid ${props => (props.active ? colors.blue_darker : colors.blue_light)};
  box-sizing: border-box;
  border-radius: 1.5rem;
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${props => (props.active ? colors.blue_darker : colors.blue_light)};
  cursor: ${props => (props.active ? 'pointer' : 'auto')}!important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;

  &:focus {
    outline: none;
  }
`;

Button.propTypes = {
  width: PropTypes.any,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

Button.defaultProps = {
  width: '100%',
  className: ''
};

function Button({children, isActive, width, className, onClick}) {
  let buttonWidth = isNumber(width) ? `${width}rem` : width;

  return (
    <ButtonStyled active={isActive} width={buttonWidth} className={className} onClick={onClick}>
      {children}
    </ButtonStyled>
  );
}

export default Button;
